export const constants = Object.freeze({
  MAX_NAME_LENGTH: 30,
  MAX_LASTNAME_LENGTH: 30,
  MAX_MATERNAL_LASTNAME_LENGTH: 30,
  MAX_EMAIL_LENGTH: 60,
  MAX_ANOTHER_DATA: 30,
  MAX_PHONE_LENGTH: 9,
  MAX_RUT_WITHOUT_POINTS_OR_DASH: 9,
  MAX_RUT_WITH_OR_WITHOUT_DASH: 10,
  MAX_SERIAL_NUMBER: 10,
  MAX_EXECUTIVE_CODE: 4,
});
